// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1sytH","on":"style_on__2zMzU","rate":"style_rate__23afc","latest":"style_latest__3uUhf","odds":"style_odds__3w3Ng"};